import type { RealtimeEvent } from './helpers';

import { differenceInMinutes, parseISO } from 'date-fns';
import { css, html } from 'react-strict-dom';

import { Box, Text } from '../../../components';
import { entries } from '../../../util';

type Props = Readonly<{
  allEvents: RealtimeEvent[];
}>;

export default function BoxTopActiveScreens({ allEvents }: Props) {
  const usersIncluded: string[] = [];
  const allScreens = [...allEvents]
    .reverse()
    .filter((event) => {
      if (!event.name) return false;
      if (differenceInMinutes(new Date(), parseISO(event.timestamp)) > 10)
        return false;
      if (usersIncluded.includes(event.user_id)) return false;
      usersIncluded.push(event.user_id);
      return true;
    })
    .map((event) => `${event.context_app_name} | ${event.name}`);

  const rankedScreens: {
    [key: string]: number;
  } = {};
  for (const screen of allScreens) {
    if (!(screen in rankedScreens)) rankedScreens[screen] = 0;
    rankedScreens[screen] += 1;
  }

  const rows = entries(rankedScreens)
    .map(([screen, num]) => ({ screen, num }))
    .sort((a, b) => b.num - a.num);

  const total = rows.reduce((carry, row) => carry + row.num, 0);

  return (
    <Box title="Top Active Screens">
      {rows.map((row, i) => (
        <html.div key={row.screen} style={styles.row}>
          <Text as="div" style={styles.cell}>
            {i + 1}.
          </Text>
          <Text as="div" style={[styles.cell, styles.flex]}>
            {row.screen}
          </Text>
          <Text as="div" bold style={styles.cell}>
            {row.num}
          </Text>
          <Text as="div" style={styles.cell}>
            {((row.num / total) * 100).toFixed(2)}%
          </Text>
        </html.div>
      ))}
    </Box>
  );
}

const styles = css.create({
  row: {
    display: 'flex',
    borderBottomWidth: 1,
    borderBottomStyle: 'solid',
    borderBottomColor: '#eee',
    ':last-child': {
      borderBottomWidth: 0,
    },
  },
  cell: {
    padding: 10,
  },
  flex: {
    flex: 1,
  },
});
